import {
  FetchArgs,
  FetchBaseQueryError,
  QueryReturnValue,
} from '@reduxjs/toolkit/query';

import { rtkQueryError } from '../store.utils';
import {
  PollEndpointStatuses,
  POLLING_INTERVAL,
  SHORT_POLLING_TIMEOUT_LIMIT,
} from './payment-api.constants';

export const generatePollingQuery = async <QueryResponse>({
  baseQuery,
  queryArgs,
}: {
  baseQuery: (
    arg: string | FetchArgs,
  ) => Promise<QueryReturnValue<unknown, FetchBaseQueryError, {}>>;
  queryArgs: FetchArgs;
}): Promise<
  QueryReturnValue<
    QueryResponse & {
      status: (typeof PollEndpointStatuses)[keyof typeof PollEndpointStatuses];
    },
    FetchBaseQueryError,
    {}
  >
> => {
  type PollingResult = {
    status: (typeof PollEndpointStatuses)[keyof typeof PollEndpointStatuses];
  } & QueryResponse;

  for (
    let elapsed = 0;
    elapsed < SHORT_POLLING_TIMEOUT_LIMIT;
    elapsed += POLLING_INTERVAL
  ) {
    const { data, error } = (await baseQuery(queryArgs)) as QueryReturnValue<
      PollingResult,
      FetchBaseQueryError,
      {}
    >;

    if (error) return { error };
    if (!data) return rtkQueryError('No data returned from polling endpoint');
    if (data.status === PollEndpointStatuses.FAILED) {
      return rtkQueryError('Failed to fetch data');
    } else if (data.status === PollEndpointStatuses.SUCCEEDED) {
      return { data };
    }

    await new Promise(resolve => setTimeout(resolve, POLLING_INTERVAL));
  }

  return rtkQueryError('Timeout while polling for result');
};
